<template>
    <div
        ref="loginBtn"
        class="kkday-auth-svc-login-button"
        @click="onClick">
        <div class="button-icon" />
        <div
            class="button-text"
            v-text="buttonText" />
    </div>
</template>

<script>
import {PopupLogin} from '../libraries/PopupLogin';
import {main as UserTypeEnum} from '../enums/UserType';

export default {
    popupLogin: undefined,
    props: {
        buttonText: {
            type: String,
            default: 'Log In',
        },
        authSvcDomain: {
            type: String,
            required: true,
        },
        userType: {
            type: String,
            required: true,
            validator: value => !!UserTypeEnum.get(value.toUpperCase()),
        },
    },
    watch: {
        authSvcDomain: {
            handler(authSvcDomain) {
                this.popupLogin = new PopupLogin(authSvcDomain);
            },
            immediate: true,
        },
    },
    methods: {
        onClick() {
            const {popupLogin, userType} = this;

            if (popupLogin.hasActivePopupWindow()) {
                return;
            }

            popupLogin.process(
                UserTypeEnum.get(userType.toUpperCase())
            )
                .then(data => {
                    this.$emit('update-auth-token', data);
                });

            this.$emit('click');
        },
    },
};
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap);

.kkday-auth-svc-login-button {
    display: flex;
    justify-content: space-between;

    height: 48px;
    line-height: 48px;

    font-family: 'Noto Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;

    border-radius: 4px;

    background-color: #26BEC9;

    cursor: pointer;

    -webkit-transition: opacity 0.1s ease-in-out;
    -moz-transition: opacity 0.1s ease-in-out;
    transition: opacity 0.1s ease-in-out;

    -webkit-user-select: none;
    -moz-transition: none;
    transition: none;
}

.kkday-auth-svc-login-button:hover {
    opacity: 0.9;
}

.kkday-auth-svc-login-button:active {
    background-color: #1e98a0;
    opacity: 1;
}

.kkday-auth-svc-login-button>.button-icon {
    width: 60px;
    height: 48px;

    background-image: url('../assets/img/icon.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 32px;

    flex-basis: 60px;
    flex-grow: 0;
    flex-shrink: 0;
}

.kkday-auth-svc-login-button>.button-text {
    color: white;
    font-weight: 700;

    flex-grow: 1;
    flex-shrink: 1;
}
</style>
